import { OnInit, ChangeDetectorRef } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { RecordService } from 'modules/core/services/record.service';
import { SnackbarService } from 'app/services/snackbar.service';
var CustomerOtherDataComponent = /** @class */ (function () {
    function CustomerOtherDataComponent(cdRef, recordService, snackbarService) {
        this.cdRef = cdRef;
        this.recordService = recordService;
        this.snackbarService = snackbarService;
        this.editMode = false;
        this.unsubscribe$ = new Subject();
        this.formKeyList = [];
        this.formQuestionKeyList = {};
        this.otherDataMetadata = {};
        this.openedPanel = [];
    }
    Object.defineProperty(CustomerOtherDataComponent.prototype, "rawOtherData", {
        get: function () {
            return this._rawOtherData;
        },
        set: function (rawOtherData) {
            if (rawOtherData && rawOtherData.results.length) {
                this._rawOtherData = rawOtherData;
                this.parseRawOtherInfo(rawOtherData.results[0].data.surveys);
            }
        },
        enumerable: true,
        configurable: true
    });
    CustomerOtherDataComponent.prototype.ngOnInit = function () {
    };
    /**
     * Parse raw other data JSON into object
     * @method parseRawOtherInfo
     */
    CustomerOtherDataComponent.prototype.parseRawOtherInfo = function (rawOtherData) {
        var otherDataJSON = JSON.parse(rawOtherData);
        var otherDataObject = {};
        Object.keys(otherDataJSON)
            .forEach(function (otherInfoFormKey) {
            otherDataObject[otherInfoFormKey] = JSON.parse(otherDataJSON[otherInfoFormKey]);
        });
        this.otherData = otherDataObject;
        this.getFormKeyList();
    };
    /**
     * Get an array of key of all forms included in other data
     * @method getFormKeyList
     */
    CustomerOtherDataComponent.prototype.getFormKeyList = function () {
        var _this = this;
        this.formKeyList = [];
        this.openedPanel = [];
        Object.keys(this.otherData).forEach(function (formKey) {
            _this.formKeyList.push(formKey);
            var questionKeys = [];
            Object.keys(_this.otherData[formKey]).forEach(function (otherDataFormQuestionKey) {
                if (otherDataFormQuestionKey === 'metadata') {
                    _this.getFormMetadata(formKey);
                }
                else {
                    questionKeys.push(otherDataFormQuestionKey);
                }
            });
            questionKeys.sort();
            _this.formQuestionKeyList[formKey] = questionKeys;
        });
        this.cdRef.detectChanges();
    };
    /**
     * Get metadata of forms
     * @method getFormMetadata
     */
    CustomerOtherDataComponent.prototype.getFormMetadata = function (formKey) {
        var rawMetadata = JSON.parse(this.otherData[formKey]['metadata']);
        var pageTitlesObject = {};
        rawMetadata.formPages.forEach(function (pageTitle) {
            pageTitlesObject[pageTitle.slice(0, 4)] = pageTitle.substring(4);
        });
        this.otherDataMetadata[formKey] = {
            formTitle: rawMetadata.formTitle,
            formPages: pageTitlesObject
        };
    };
    /**
     * Remove index number in questions
     * @method parseQuestionFormat
     */
    CustomerOtherDataComponent.prototype.parseQuestionFormat = function (question) {
        return question.replace(/^(\([0-9]+\))+/, '');
    };
    CustomerOtherDataComponent.prototype.isArray = function (object) {
        return Array.isArray(object);
    };
    CustomerOtherDataComponent.prototype.trackByFn = function (i, item) {
        return i;
    };
    /**
     * Check whether the answer should be shown as string
     * @method showAnswerAsString
     */
    CustomerOtherDataComponent.prototype.showAnswerAsString = function (answer) {
        if (typeof answer === 'object') {
            if (Array.isArray(answer)) {
                if (answer.every(function (item) { return typeof item === 'string'; })) {
                    return true;
                }
                else {
                    this.getObjectAnswerKeyList(answer);
                    return false;
                }
            }
            return false;
        }
        else {
            return true;
        }
        this.cdRef.detectChanges();
    };
    /**
     * Get an array of keys of fields in the answer if the answer is in object format
     * @method getObjectAnswerKeyList
     */
    CustomerOtherDataComponent.prototype.getObjectAnswerKeyList = function (answer) {
        return Object.keys(answer);
    };
    /**
     * Convert the answer into clean string if the answer is originally in boolean or array of string format
     * @method parseStringAnswerFormat
     */
    CustomerOtherDataComponent.prototype.parseStringAnswerFormat = function (answer) {
        if (typeof answer === 'boolean') {
            return answer ? 'YES' : 'NO';
        }
        else if (Array.isArray(answer)) {
            return answer.join(',');
        }
        else {
            return answer;
        }
    };
    /**
     * Expand a form
     * @method openPanel
     */
    CustomerOtherDataComponent.prototype.openPanel = function (index) {
        this.openedPanel = this.openedPanel.concat([index]);
    };
    /**
     * Collapse a form
     * @method closePanel
     */
    CustomerOtherDataComponent.prototype.closePanel = function (index) {
        this.openedPanel = this.openedPanel.filter(function (panelIndex) { return panelIndex !== index; });
    };
    /**
     * Submit updated other data
     * @method submit
     */
    CustomerOtherDataComponent.prototype.submit = function (updatedFormKey) {
        var _this = this;
        var dataToSend = {};
        this.formKeyList.forEach(function (formKey) {
            dataToSend[formKey] = JSON.stringify(_this.otherData[formKey]);
        });
        if (this.editMode) {
            this.recordService
                .updateOtherData({
                otherDataId: this.rawOtherData.results[0].id,
                record: this.rawOtherData.results[0].record,
                customer: this.rawOtherData.results[0].customer,
                data: {
                    surveys: JSON.stringify(dataToSend)
                }
            })
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe(function (res) {
                if (_this.otherDataMetadata[updatedFormKey] && _this.otherDataMetadata[updatedFormKey].formTitle) {
                    _this.snackbarService.success(_this.otherDataMetadata[updatedFormKey].formTitle + " updated successfully!");
                }
                else {
                    _this.snackbarService.success(updatedFormKey + " updated successfully!");
                }
            }, function (error) {
                if (_this.otherDataMetadata[updatedFormKey] && _this.otherDataMetadata[updatedFormKey].formTitle) {
                    _this.snackbarService.error("Failed to update " + _this.otherDataMetadata[updatedFormKey].formTitle + ", please try again later.");
                }
                else {
                    _this.snackbarService.error("Failed to update " + updatedFormKey + ", please try again later.");
                }
            });
        }
    };
    return CustomerOtherDataComponent;
}());
export { CustomerOtherDataComponent };
